export enum InvitationType {
  USER = "USER",
  COMPANY = "COMPANY",
  SHAREHOLDER_REPRESENTATIVE = "SHAREHOLDER_REPRESENTATIVE",
  SHAREHOLDER = "SHAREHOLDER",
}

export type Invitation = {
  invitationId: string;
  invitationType: InvitationType;
  companyName: string;
  recipientEmail: string;
  hasExistingUser: boolean;
  invitedByName: string;
  invitedByEmail: string;
  customRoleName?: string;
  shareholderName?: string;
  isCompanyShareholder?: boolean;
};

export type InvitationRequest = {
  companyName: string;
  requestedByName: string;
  requestedByEmail: string;
  requestedAt: string;
  recipientEmail: string;
};

export type BatchInvitation = {
  batchInvitationId: string;
  companyNames: string[];
  invitedByName: string;
  invitedByEmail: string;
  recipientEmail: string;
  hasExistingUser: boolean;
};
